import hvpAuthenticatedApi from "../api/hvpAuthenticatedApi";
import { toMexicoStartOfDay } from "../shared/helpers";
import {
  CollaboratorDayShift,
  IWeekShift,
  IWeekShiftBase,
  IWeekShiftPayrollEntity,
  IWeekShiftResponse,
} from "../shared/types";
import { BaseServiceLegacy } from "./base.service.legacy";

export class WeekShiftService extends BaseServiceLegacy<
  IWeekShift,
  IWeekShiftBase
> {
  constructor() {
    super("/week-shifts");
  }

  async suggestReceptionists(
    id: string,
    options: { force?: boolean } = {}
  ): Promise<{ shifts: CollaboratorDayShift[] }> {
    const response = await hvpAuthenticatedApi.post<{
      ok: boolean;
      data: { shifts: CollaboratorDayShift[] };
    }>(`${this.API_URL}/${id}/suggest-receptionists`, null, {
      params: options.force ? { force: "true" } : undefined,
    });
    return response.data.data;
  }

  public transformResponseToMxEntity(
    response: IWeekShiftResponse
  ): IWeekShiftPayrollEntity {
    return {
      ...response,
      startingDate: toMexicoStartOfDay(response.startingDate),
      endingDate: toMexicoStartOfDay(response.endingDate),
      shifts: response.shifts.map((shift) => ({
        ...shift,
        startingTime: shift.startingTime
          ? toMexicoStartOfDay(shift.startingTime)
          : undefined,
        endingTime: shift.endingTime
          ? toMexicoStartOfDay(shift.endingTime)
          : undefined,
        shiftDate: toMexicoStartOfDay(shift.shiftDate),
      })),
    };
  }
}
